import { toPersistedTimelineActivity } from "@/features/chat/phase1/persistedTimelineActivity";
import { mergeSnapshotRows } from "@/features/chat/phase1/timelineRows";
import { toWorkStatusSnapshot } from "@/features/chat/phase1/workStatusThoughts";
import { messageCardBlocks, messageResponseParts } from "./conversationCardBlocks";

function standaloneExchange(metadata, id) {
  if (!metadata.workflow_id) return {};
  return { exchangeId: id, versionIndex: 0, assistantVersionIndex: 0 };
}

function restoredTimeline(metadata) {
  const workStatus = toWorkStatusSnapshot(metadata.work_status);
  if (workStatus)
    return { workStatus, activity: mergeSnapshotRows([], workStatus) };
  const activity = toPersistedTimelineActivity(metadata.timeline_activity);
  return activity.length ? { activity } : {};
}

export function assistantMessageFields(metadata, id) {
  const responseParts = messageResponseParts(metadata, id);
  const inlineReviewIds = new Set(
    responseParts
      .filter((part) => part.type === 'integration_access_request')
      .map((part) => part.review_id),
  );
  const blocks = messageCardBlocks(metadata, id).filter(
    (block) => block.type !== 'integration_access_request' || !inlineReviewIds.has(block.review_id),
  );
  return {
    ...standaloneExchange(metadata, id),
    ...restoredTimeline(metadata),
    ...(metadata.public_timeline ? { hasPublicTimeline: true } : {}),
    ...(metadata.streaming ? { demoStreamActive: true } : {}),
    ...(metadata.incomplete
      ? {
          phase1Error: true,
          phase1ErrorMessage: String(
            metadata.stream_error || "The response stopped early.",
          ),
        }
      : {}),
    ...(blocks.length ? { blocks } : {}),
    ...(responseParts.length ? { responseParts } : {}),
  };
}
